import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Route guard for role-based access. `roles` can be a string or array.
 */
export default function RequireRole({ roles, redirectTo = "/login", children }) {
    const { user, loading } = useAuth();
    const allowed = Array.isArray(roles) ? roles : [roles];

    if (loading) {
        return (
            <div className="co-container py-24 text-center text-[hsl(var(--muted-foreground))]" data-testid="require-role-loading">
                Caricamento…
            </div>
        );
    }
    if (!user) return <Navigate to={redirectTo} replace />;
    if (!allowed.includes(user.role)) return <Navigate to="/" replace />;
    return children;
}
